import { Col, Container } from "reactstrap";
import { H2, Image, P } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { BackToHomePage, Error400Content } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";
import { ErrorProp } from "../../../Type/CommonComponant";

const CommonErrorPage = ({ color, page }: ErrorProp) => {
  return (
    <div className="page-wrapper compact-wrapper">
      <div className="error-wrapper">
        <Container>
          <Image className="img-100" src={dynamicImage("other-images/sad.gif")} alt="" />
          <div className="error-heading">
            <H2 className={`headline font-${color}`}>{page}</H2>
          </div>
          <Col md="8" className="offset-md-2">
            <P className="sub-content">{Error400Content}</P>
          </Col>
          <div>
            <Link className={`btn btn-${color} btn-lg`} to={`${process.env.PUBLIC_URL}/dashboard/default`}>
              {BackToHomePage}
            </Link>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default CommonErrorPage;
